import { computed, Injectable, signal } from '@angular/core';
import { VARIANT } from '@cpd-app/core-module/constants/pathway-courses.const';
import { STORAGE_KEY } from '@cpd-app/core-module/constants/storage-key.const';
import { sample } from 'lodash';

@Injectable()
export class SponsorBannerAssignService {
  private readonly bannerVariant$ = signal<string>(null);

  public readonly bannerVariant = computed(() => this.bannerVariant$());

  public constructor() {
    const sessionVariantValue = sessionStorage.getItem(STORAGE_KEY.VARIANT_KEY);

    if (sessionVariantValue) {
      this.bannerVariant$.set(sessionVariantValue);
    } else {
      this.randomVariant();
    }
  }

  private randomVariant(): void {
    const collections = Object.values(VARIANT);

    const result: string = sample(collections);

    sessionStorage.setItem(STORAGE_KEY.VARIANT_KEY, result);
    this.bannerVariant$.set(result);
  }
}
